import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d6932f4c")

_pushScopeId("data-v-d6932f4c")
const _hoisted_1 = { class: "t-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Sign Up Now")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Trade on the best mobile trading platform")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sign Up")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Pic, {
      type: "svg",
      src: "home/user",
      width: "56",
      height: "56"
    }),
    _createVNode(_component_t, {
      as: "p",
      path: "home_9",
      class: "f-xxl f-bold mt-20"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_t, {
      as: "p",
      path: "home_10",
      class: "mt-16"
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/login",
      custom: ""
    }, {
      default: _withId(({navigate}) => [
        _createVNode("button", {
          class: "login mt-16 f-bold br-lg",
          onClick: navigate
        }, [
          _createVNode(_component_t, { path: "home_11" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ], 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
})